import React from "react";
import { motion } from "framer-motion";
import {
  AnimatedModal,
  ModalContent,
  ModalHeader,
} from "../modals/AnimatedModal";
import DeliveryRadiusList from "./DeliveryRadiusList";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";

const listVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2,
    },
  },
};

export default function DeliveryRadiusListModal({ show, closeModal }) {
  return (
    <AnimatedModal
      isOpen={show}
      onClose={closeModal}
      width="75%"
      maxWidth="1400px"
      maxHeight="85vh"
    >
      <ModalHeader
        title="Raios de Entrega"
        icon={TrackChangesIcon}
        onClose={closeModal}
      />
      <ModalContent padding={0}>
        <motion.div variants={listVariants} initial="hidden" animate="visible">
          <DeliveryRadiusList />
        </motion.div>
      </ModalContent>
    </AnimatedModal>
  );
}
